import { z } from 'zod';
import { PartnerMaterialAdminSchema, PartnerMaterialCategorySchema, PartnerMaterialTextSchema, PartnerMaterialVideoUrlSchema } from '../../entities/partner-material/partner-material.schema';
/**
 * Update Partner Material Request
 * PATCH /api/v2/admin/partner-materials/:id
 *
 * `videoUrl` applies to videos only; the kind itself is fixed at creation. A `null` description clears it; an absent one keeps it.
 */ export const UpdatePartnerMaterialRequestSchema = z.object({
    category: PartnerMaterialCategorySchema.optional(),
    title: PartnerMaterialTextSchema.optional(),
    description: PartnerMaterialTextSchema.partial().nullable().optional(),
    videoUrl: PartnerMaterialVideoUrlSchema.optional(),
    active: z.boolean().optional(),
    position: z.number().int().min(0).optional()
});
export const UpdatePartnerMaterialResponseSchema = z.object({
    data: PartnerMaterialAdminSchema
});

//# sourceMappingURL=update-partner-material.schema.js.map